import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { aps_item } from "../../../json/aps";
import "../stylessh.css";

const Aps = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderText = () => {
    const { aps_item_text, aps_item_sec_tetx, aps_item_trd_text, aps_item_list_ben, aps_item_list } = aps_item[0];

    return (
      <div>
        <p className="text-justify">{aps_item_text}</p>
        <p className="text-justify">{aps_item_sec_tetx}</p>
        <p className="text-justify">{aps_item_trd_text}</p>
        <ul>
          {aps_item_list_ben.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <ul className="list-mark">
          {aps_item_list.map((item, index) => (
            <li key={index}>{typeof item === "object" ? <a href={item.url}>{item.label}</a> : item}</li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Administración del Patrimonio Social</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row">
        {renderText()}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3747.611942665422!2d-98.77255088469536!3d20.06669058652736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a0e074f77edb%3A0x78528708b4171a59!2sBlvrd%20Nuevo%20Hidalgo%20102%2C%20El%20Venado%2C%2042083%20Pachuca%20de%20Soto%2C%20Hgo.!5e0!3m2!1ses-419!2smx!4v1666903418206!5m2!1ses-419!2smx"
          width="100%"
          height="300"
          frameBorder="0"
          style={{ border: 0, marginBottom: 50 }}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Aps;
